import { render } from "./QuestHighlightSlide.vue?vue&type=template&id=27c977c0"
import script from "./QuestHighlightSlide.vue?vue&type=script&lang=js"
export * from "./QuestHighlightSlide.vue?vue&type=script&lang=js"

import "./QuestHighlightSlide.vue?vue&type=style&index=0&id=27c977c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__